export interface IGetVehicleByIdFiltersDto {
    tripId?: string;
    includeExternal?: boolean;
    includeSharedFinished?: boolean;
}
